<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-stretch.mb-5
      .col
        .row.flex-row.h-100
          .col-12
            a.button-previous.mr-2(@click="$router.go(-1)")
              i.fas.fa-chevron-left
            h1.m-0.font-italic.d-inline-block.align-middle
              | Pauta evaluación 
              span.text-nowrap.ad_text-secondary {{ $route.params.type }}
              | &nbsp;de&nbsp;
              span.ad_text-secondary {{ collab.name }}
            div(v-if="type == 'SDA' || type == 'SDB' || type == 'CP'")
              | &nbsp;realizada a&nbsp;                        
              span.ad_text-secondary {{ collab_involve.name }}
          .col.d-flex.align-self-end
            .h2
              | Historial
          
      .col-auto.text-right
        h1.m-0.font-italic
          small Semana {{ moment(guidelineanswered.creation_date).format("W") }}
        .row.d-flex.justify-content-end
          .col-auto
            .h4.d-flex.justify-content-between
              span.font-weight-bold.mr-3 Fecha de ejecución:
              em {{ moment(guidelineanswered.creation_date).format("DD/MM/YYYY") }}
            .h4.d-flex.justify-content-between
              span.font-weight-bold.mr-3 Usuario ejecutor:
              em {{user.name}}

    section
      .d-flex.row.flex-row.flex-row-reverse.align-items-start.mt-4

        .col-auto
          .ad_border1-secondary.rounded-lg.overflow-hidden
            table.table.w-100.m-0.text-center
              thead
                tr
                  th Escala
                  th Nivel de ejecución
              tbody
                tr
                  td.text-center N/A
                  td No aplica
                tr
                  td.text-center 0
                  td No realizado
                tr
                  td.text-center 1
                  td Medianamente realizado
                tr
                  td.text-center 2
                  td Completamente realizado
        .col
          .card.p-0.ad_border2-primaryLight.rounded-xl
            .card-body
              .row
                .col-2
                  .h4.mb-3.ad_text-primary
                    | Pregunta
                .col
                  .h4.mb-3.ad_text-primary
                    | ¿Qué quieres lograr con tu equipo en este <em>{{ $route.params.type }}</em>?
                .col-auto
              .ad_bg-gray.rounded-lg.py-4
                .row.mx-0.py-2.border-bottom.align-items-center(v-for="(question, n) in question_score")
                  .col-2
                    p.m-0
                    strong {{ question.stage }}
                  .col.border-left.border-right
                    ul
                      li
                        p.mb-1 {{ question.evaluation }}
                  .col-auto.d-flex.flex-nowrap
                    p
                    strong {{ question.score !== null ? question.score : 'N/A'}}

                h3 Puntacion final: {{ guidelineanswered[$route.params.type].final_score.toFixed(2) }}%
    hr.my-4
    h3.ad_text-grayMedio.mb-3
      i Comentarios
    .col-12.mt-5
      .row.mb-3(v-for="(comment) in guidelinesComments.slice().reverse()")
            .col-4.pr-0
              p.font-weight-bold.m-0 {{comment.user.name}}
              small.d-block {{ moment(comment.creation_date).format("DD-MM-YYYY") }}
              small.d-block {{ moment(comment.creation_date).format("HH:mm") }} hrs.
            .col-8.pl-0
              .dialog-box
                p {{comment.text}}                  
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex';

export default {
  name: 'PautaDetail',

  data () {
    return {
      user: {},
      collab: { name: '' },
      guidelineanswered: { creation_date: '' },
      guidelines: [],
      guidelinesComments: [],
      question_score: [],
      collab_involve: { name: '' },
      type: null
    }
  },
  methods: {
    moment,
    ...mapActions('user', [
      'getUserById'
    ]),
    ...mapActions('consultant', [
      'getEvaluationQuestions',
      'getAnsweredEvaluation'
    ]),
    ...mapActions('guidelinecomment', [
      'commentsByType'      
    ]),
  },
  mounted() {
    const vm = this;
    const { id } = vm.$store.state.auth.user
    vm.type = vm.$route.params.type
    vm.user = vm.$store.getters['auth/getUserInfo']    
    vm.getUserById(vm.$route.params.collab).then(response => {
      vm.collab = response
    })    
    const data = {
        id: vm.$route.params.id,
        type: vm.type
    }
    vm.getAnsweredEvaluation(data).then(() => {
      const loading = vm.$toast.loading('Cargando...')
      vm.guidelineanswered = vm.$store.getters['consultant/getAnsweredEvaluation']  
      if (vm.guidelineanswered) {
        vm.getUserById(vm.guidelineanswered[vm.type].collab_involve).then(response => {
          vm.collab_involve = response
        })
        vm.getEvaluationQuestions(vm.$route.params.type).then(() => {
          vm.guidelines = vm.$store.getters['consultant/getGuidelines']
          if (vm.guidelines.length > 0) {
            for (let indexg in vm.guidelines) {
              for (let indexa in vm.guidelineanswered[vm.type].questions) {
                if (vm.guidelines[indexg]._id == vm.guidelineanswered[vm.type].questions[indexa]._id) {
                  vm.question_score.push({
                    _id: vm.guidelines[indexg]._id,
                    score: vm.guidelineanswered[vm.type].questions[indexa].score,
                    stage: vm.guidelines[indexg].stage,
                    evaluation: vm.guidelines[indexg].evaluation
                  })
                }
              }
            }
          } else {
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: 'Ha habido un error',
              closeable: true,
              duration: 5000
            })
          }
        })
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Ha habido un error',
          closeable: true,
          duration: 5000
        })
      }

      let queryComments = {
        user_evaluated: vm.$route.params.collab,
        type : vm.type
      }
      vm.commentsByType(queryComments).then(response => {
        if (response.guidelinesComments.hasOwnProperty(vm.type)) {
          vm.guidelinesComments = response.guidelinesComments[vm.type];
        }
      })
      loading.hide();
    })    
  }
}
</script>



// WEBPACK FOOTER //
// src/views/consultor-externo/consultor-externo-pauta-historial.vue